// MeisterMind · Live-Stundenplan für Moodle
// Eigenständiger Baustein ohne Bibliotheken. Wird als <script> in einen Moodle-Textblock eingefügt,
// lädt die freigegebenen Termine eines Kurses über die Supabase-Funktion moodle_stundenplan
// und aktualisiert sich selbst. Alle Texte aus der Datenbank werden maskiert (kein HTML aus Daten).

export interface MoodleTermin {
  datum: string; beginn: string; ende: string; ue: number; form: 'praesenz' | 'online';
  status: 'freigegeben' | 'entfaellt'; hinweis: string | null; thema: string | null; oberthema: string | null;
  fachbereich: { name: string; kuerzel: string; farbe: string } | null;
  dozent: { kuerzel: string; name: string; farbe: string } | null; raum: string | null;
}
export interface MoodleDaten {
  kurs: { kennung: string; bezeichnung: string; beginn: string; ende: string; form: string; standort: string | null;
    links: { text: string; url: string }[]; planstand: string };
  mandant: { name: string; einheit: string | null; logo: string | null; farbe: string };
  zeitfenster: { bezeichnung: string; beginn: string; ende: string }[];
  feiertage: { datum: string; bezeichnung: string }[];
  termine: MoodleTermin[];
}
export interface StartKonfig { url: string; key: string; token: string; intervallSek?: number }

const TAGE = ['Sonntag', 'Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'];
const esc = (s: unknown) => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]!));
const sichereUrl = (u: string) => /^https?:\/\//i.test(u) ? esc(u) : '#';
const pad = (n: number) => String(n).padStart(2, '0');
const d = (s: string) => { const [j, m, t] = s.split('-').map(Number); return new Date(j, m - 1, t, 12); };
const iso = (x: Date) => `${x.getFullYear()}-${pad(x.getMonth() + 1)}-${pad(x.getDate())}`;
const plus = (s: string, n: number) => { const x = d(s); x.setDate(x.getDate() + n); return iso(x); };
const montag = (s: string) => plus(s, -((d(s).getDay() + 6) % 7));
const de = (s: string) => `${s.slice(8, 10)}.${s.slice(5, 7)}.`;
const tag = (s: string) => TAGE[d(s).getDay()];
function kw(s: string) {
  const x = d(s); const t = new Date(Date.UTC(x.getFullYear(), x.getMonth(), x.getDate()));
  const w = t.getUTCDay() || 7; t.setUTCDate(t.getUTCDate() + 4 - w);
  return Math.ceil(((t.getTime() - Date.UTC(t.getUTCFullYear(), 0, 1)) / 864e5 + 1) / 7);
}

const CSS = `
.mmsp{--p:#073070;--a:#408FE5;--ink:#242424;--grau:#5A5A5A;--hell:color-mix(in srgb,var(--p) 6%,#fff);--linie:color-mix(in srgb,var(--p) 20%,#fff);
 margin:6px 0 22px;font-family:Calibri,'Segoe UI',Arial,sans-serif;color:var(--ink);line-height:1.45}
.mmsp *{box-sizing:border-box}
.mmsp-karte{background:#fff;border:1px solid var(--linie);border-radius:16px;overflow:hidden;box-shadow:0 8px 24px color-mix(in srgb,var(--p) 10%,transparent)}
.mmsp-band{height:8px;background:linear-gradient(90deg,var(--p) 0%,var(--a) 100%)}
.mmsp-innen{padding:clamp(16px,3vw,26px)}
.mmsp-kopf{display:flex;justify-content:space-between;gap:16px;flex-wrap:wrap;align-items:flex-start}
.mmsp-kopf>div:first-child{flex:1 1 320px;min-width:0}
.mmsp-kicker{font-family:Arial,Helvetica,sans-serif;font-size:.76rem;font-weight:bold;letter-spacing:.14em;text-transform:uppercase;color:var(--a);margin-bottom:6px}
.mmsp h2{margin:0 0 6px;font-family:Arial,Helvetica,sans-serif;font-size:1.5rem;line-height:1.2;color:var(--p)}
.mmsp h3{margin:24px 0 12px;font-family:Arial,Helvetica,sans-serif;font-size:1.15rem;color:var(--p)}
.mmsp p{margin:0;color:var(--grau)}
.mmsp-rechts{flex:0 0 auto;text-align:right}
.mmsp-logo{display:block;height:38px;width:auto;margin-left:auto}
.mmsp-pille{margin-top:8px;display:inline-block;background:var(--hell);border:1px solid var(--linie);border-radius:999px;padding:5px 12px;color:var(--p);font-weight:bold;font-size:.82rem}
.mmsp-heute{margin-top:18px;background:linear-gradient(135deg,var(--p) 0%,color-mix(in srgb,var(--p) 80%,var(--a)) 60%,var(--a) 140%);color:#fff;border-radius:14px;padding:20px 22px}
.mmsp-heute .mmsp-kicker{color:#B8D2F1}
.mmsp-heute-titel{font-family:Arial,Helvetica,sans-serif;font-size:clamp(1.1rem,2.6vw,1.45rem);font-weight:bold;margin-bottom:4px}
.mmsp-knoepfe{margin-top:12px;display:flex;flex-wrap:wrap;gap:8px}
.mmsp-knopf{display:inline-flex;align-items:center;min-height:44px;padding:10px 16px;border-radius:10px;border:2px solid var(--p);background:#fff;color:var(--p)!important;-webkit-text-fill-color:var(--p);text-decoration:none!important;font-weight:bold;font-size:.94rem;cursor:pointer;font-family:inherit}
.mmsp-knopf.voll{background:var(--p);color:#fff!important;-webkit-text-fill-color:#fff}
.mmsp-wochen{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(300px,100%),1fr));gap:12px}
.mmsp-woche{background:var(--hell);border:1px solid var(--linie);border-radius:12px;padding:12px 14px;min-width:0}
.mmsp-woche-kopf{display:flex;justify-content:space-between;align-items:center;gap:8px}
.mmsp-woche-kopf strong{font-family:Arial,Helvetica,sans-serif;color:var(--p)}
.mmsp-woche-kopf span{font-size:.8rem;color:var(--grau)}
.mmsp-tag{margin-top:10px;padding-top:8px;border-top:1px solid var(--linie)}
.mmsp-tag.ist-heute{outline:3px solid var(--a);outline-offset:3px;border-radius:6px}
.mmsp-tag-name{font-weight:bold;color:var(--p)}
.mmsp-heute-marke{background:var(--p);color:#fff;border-radius:999px;padding:1px 8px;font-size:.72rem;margin-left:4px}
.mmsp-frei{margin-top:6px;font-size:.88rem;color:var(--grau);font-style:italic}
.mmsp-slot{display:flex;gap:10px;align-items:flex-start;margin-top:8px;background:#fff;border:1px solid var(--linie);border-radius:10px;padding:8px 10px;border-left:5px solid var(--fb,var(--linie))}
.mmsp-heute .mmsp-slot{background:rgba(255,255,255,.12);border-color:rgba(255,255,255,.28);border-left-color:var(--fb,rgba(255,255,255,.5));color:#fff}
.mmsp-kz{flex:0 0 auto;min-width:36px;text-align:center;border-radius:8px;color:#fff;font-weight:bold;padding:3px 6px;font-family:Arial,Helvetica,sans-serif;font-size:.8rem}
.mmsp-slot-text{line-height:1.35;min-width:0}
.mmsp-klein{opacity:.85;font-size:.88em}
.mmsp-online{display:inline-block;font-size:.72rem;font-weight:bold;border-radius:999px;padding:1px 8px;background:var(--p);color:#fff;margin-left:4px}
.mmsp-heute .mmsp-online{background:#fff;color:var(--p)}
.mmsp-entfaellt .mmsp-slot-haupt{text-decoration:line-through;opacity:.7}
.mmsp-entfaellt{border-style:dashed}
.mmsp-hinweis{display:inline-block;margin-top:3px;font-weight:bold;font-size:.88em;color:var(--p)}
.mmsp-heute .mmsp-hinweis{color:#fff}
.mmsp details{margin-top:12px;border:1px solid var(--linie);border-radius:12px;background:#fff;padding:10px 14px}
.mmsp details.alt{background:var(--hell)}
.mmsp summary{cursor:pointer;font-weight:bold;color:var(--p)}
.mmsp details .mmsp-wochen{margin-top:12px}
.mmsp details.alt .mmsp-wochen{opacity:.8}
.mmsp-leute{display:grid;grid-template-columns:repeat(auto-fit,minmax(min(230px,100%),1fr));gap:10px 16px}
.mmsp-person{display:flex;gap:10px;align-items:flex-start;min-width:0;font-size:.88rem}
.mmsp-fuss{margin-top:14px;font-size:.8rem;color:var(--grau)}
.mmsp-fehler{margin-top:10px;padding:8px 12px;border-radius:8px;background:#FDF1E2;color:#8A4B06;font-size:.88rem}
`;

function stilEinfuegen() {
  if (document.getElementById('mmsp-stil')) return;
  const s = document.createElement('style'); s.id = 'mmsp-stil'; s.textContent = CSS; document.head.appendChild(s);
}

function fensterName(daten: MoodleDaten, t: MoodleTermin) {
  const f = daten.zeitfenster.find(z => z.beginn === t.beginn && z.ende === t.ende);
  return f ? f.bezeichnung : (t.beginn >= '17:00' ? 'Abend' : 'Sondertermin');
}
function slotHtml(daten: MoodleDaten, t: MoodleTermin) {
  const thema = [t.fachbereich?.name, t.oberthema && !(t.fachbereich && t.oberthema.includes(t.fachbereich.name)) ? t.oberthema : null, t.thema].filter(Boolean).join(' · ') || 'Thema folgt';
  const dozent = t.dozent ? esc(t.dozent.name) : 'Dozent/in wird bekannt gegeben';
  const ort = t.form === 'online' ? '<span class="mmsp-online">online</span>' : (t.raum ? ` · ${esc(t.raum)}` : '');
  return `<div class="mmsp-slot ${t.status === 'entfaellt' ? 'mmsp-entfaellt' : ''}" style="--fb:${esc(t.fachbereich?.farbe ?? '')}">
    <span class="mmsp-kz" style="background:${esc(t.dozent?.farbe ?? '#6B7785')}">${esc(t.dozent?.kuerzel ?? 'NN')}</span>
    <span class="mmsp-slot-text"><span class="mmsp-slot-haupt"><strong>${esc(fensterName(daten, t))} · ${esc(t.beginn)}–${esc(t.ende)}</strong>${t.form === 'online' ? ort : ''}
    <br>${esc(thema)}<br><span class="mmsp-klein">${dozent}${t.form !== 'online' ? ort : ''}</span></span>
    ${t.status === 'entfaellt' ? `<br><span class="mmsp-hinweis">Entfällt${t.hinweis ? ': ' + esc(t.hinweis) : ''}</span>` : t.hinweis ? `<br><span class="mmsp-hinweis">${esc(t.hinweis)}</span>` : ''}
    </span></div>`;
}

/** Zeichnet den Stundenplan in ein Element. heute = 'YYYY-MM-DD' (für Tests), sonst Systemdatum. */
export function zeichne(el: HTMLElement, daten: MoodleDaten, heuteDatum?: string, fehler?: string) {
  stilEinfuegen();
  const heute = heuteDatum ?? iso(new Date());
  const proTag = new Map<string, MoodleTermin[]>();
  for (const t of daten.termine) proTag.set(t.datum, [...(proTag.get(t.datum) ?? []), t]);
  const feiertag = new Map(daten.feiertage.map(f => [f.datum, f.bezeichnung]));

  // Wochen von Kursbeginn bis Kursende
  const wochen: string[] = [];
  for (let m = montag(daten.kurs.beginn); m <= daten.kurs.ende; m = plus(m, 7)) wochen.push(m);
  const tageDerWoche = (m: string) => {
    const tage = [0, 1, 2, 3, 4].map(i => plus(m, i));
    for (const i of [5, 6]) if (proTag.has(plus(m, i))) tage.push(plus(m, i));
    return tage.filter(t => t >= daten.kurs.beginn && t <= daten.kurs.ende);
  };
  const wocheHtml = (m: string) => {
    const tage = tageDerWoche(m);
    let h = `<div class="mmsp-woche"><div class="mmsp-woche-kopf"><strong>KW ${kw(m)}</strong><span>${de(tage[0] ?? m)} bis ${de(tage[tage.length - 1] ?? plus(m, 4))}</span></div>`;
    for (const t of tage) {
      const termine = proTag.get(t) ?? [];
      h += `<div class="mmsp-tag ${t === heute ? 'ist-heute' : ''}"><div class="mmsp-tag-name">${tag(t)}, ${de(t)}${t === heute ? '<span class="mmsp-heute-marke">heute</span>' : ''}</div>`;
      if (feiertag.has(t)) h += `<div class="mmsp-frei">${esc(feiertag.get(t))} – kein Unterricht</div>`;
      else if (!termine.length) h += `<div class="mmsp-frei">kein Unterricht</div>`;
      h += termine.map(x => slotHtml(daten, x)).join('') + '</div>';
    }
    return h + '</div>';
  };

  // Aktuelle Woche: die Woche mit heute (Wochenende zählt zur vergangenen Woche bis Sonntag)
  let idx = wochen.findIndex(m => heute >= m && heute <= plus(m, 6));
  if (idx < 0) idx = heute < (wochen[0] ?? '') ? 0 : wochen.length;
  const vorn = wochen.slice(idx, idx + 2), rest = wochen.slice(idx + 2), alt = wochen.slice(0, idx);

  const naechster = [...proTag.keys()].sort().find(t => t >= heute && (proTag.get(t) ?? []).some(x => x.status !== 'entfaellt'));
  const heuteBox = naechster
    ? `<div class="mmsp-kicker">${naechster === heute ? 'Heute im Unterricht' : 'Nächster Unterrichtstag'}</div>
       <div class="mmsp-heute-titel">${tag(naechster)}, ${de(naechster)}${naechster.slice(0, 4)} · KW ${kw(naechster)}</div>
       ${(proTag.get(naechster) ?? []).map(x => slotHtml(daten, x)).join('')}`
    : `<div class="mmsp-heute-titel">Keine weiteren Termine</div><p style="color:#B8D2F1">Der Stundenplan für die folgenden Wochen wird hier veröffentlicht, sobald er freigegeben ist.</p>`;

  // Dozierende und ihre Fächer
  const leute = new Map<string, { d: NonNullable<MoodleTermin['dozent']>; f: Set<string> }>();
  for (const t of daten.termine) if (t.dozent && t.status !== 'entfaellt') {
    const e = leute.get(t.dozent.kuerzel) ?? { d: t.dozent, f: new Set<string>() };
    if (t.fachbereich) e.f.add(t.fachbereich.name);
    leute.set(t.dozent.kuerzel, e);
  }
  const zeiten = daten.zeitfenster.map(z => `<strong style="color:#242424">${esc(z.bezeichnung)} ${esc(z.beginn)}–${esc(z.ende)} Uhr</strong>`).join(' und ');

  el.innerHTML = `<div class="mmsp" lang="de" style="--p:${esc(daten.mandant.farbe || '#073070')}"><div class="mmsp-karte"><div class="mmsp-band"></div><div class="mmsp-innen">
    <div class="mmsp-kopf"><div>
      <div class="mmsp-kicker">Stundenplan · ${esc(daten.kurs.kennung)}</div>
      <h2>${esc(daten.kurs.bezeichnung)}</h2>
      <p>${daten.kurs.form === 'online' ? 'Online-Unterricht' : `Unterricht${daten.kurs.standort ? ' in ' + esc(daten.kurs.standort) : ''}`}${zeiten ? ` nach Stundenplan, ${zeiten}` : ''}.</p>
    </div><div class="mmsp-rechts">
      ${daten.mandant.logo ? `<img class="mmsp-logo" src="${sichereUrl(daten.mandant.logo)}" alt="${esc(daten.mandant.name)}">` : `<div style="font-weight:bold;color:var(--p)">${esc(daten.mandant.name)}</div>`}
      <div class="mmsp-pille">Planstand: ${esc(daten.kurs.planstand)}</div>
    </div></div>
    <div class="mmsp-heute">${heuteBox}</div>
    <div class="mmsp-knoepfe">
      ${daten.kurs.links.map((l, i) => `<a class="mmsp-knopf ${i === 0 ? 'voll' : ''}" href="${sichereUrl(l.url)}">${esc(l.text)} →</a>`).join('')}
      <button type="button" class="mmsp-knopf" data-mmsp-druck>Stundenplan drucken oder als PDF speichern</button>
    </div>
    <h3>${idx < wochen.length ? 'Diese und nächste Woche' : 'Stundenplan'}</h3>
    <div class="mmsp-wochen">${vorn.length ? vorn.map(wocheHtml).join('') : '<p>Keine weiteren Unterrichtswochen.</p>'}</div>
    ${rest.length ? `<details><summary>Weitere Wochen anzeigen (${rest.length})</summary><div class="mmsp-wochen">${rest.map(wocheHtml).join('')}</div></details>` : ''}
    ${alt.length ? `<details class="alt"><summary>Vergangene Wochen anzeigen (${alt.length})</summary><div class="mmsp-wochen">${alt.map(wocheHtml).join('')}</div></details>` : ''}
    ${leute.size ? `<h3>Dozierende und Fächer</h3><div class="mmsp-leute">${[...leute.values()].sort((a, b) => a.d.name.split(' ').pop()!.localeCompare(b.d.name.split(' ').pop()!, 'de')).map(x =>
      `<div class="mmsp-person"><span class="mmsp-kz" style="background:${esc(x.d.farbe)}">${esc(x.d.kuerzel)}</span><span><strong style="color:var(--p)">${esc(x.d.name)}</strong><br><span style="color:#5a5a5a">${esc([...x.f].join('; '))}</span></span></div>`).join('')}</div>` : ''}
    <p class="mmsp-fuss">Der heutige Tag ist hervorgehoben. Der Stundenplan aktualisiert sich automatisch; maßgeblich ist der jeweils aktuelle Planstand.</p>
    ${fehler ? `<div class="mmsp-fehler">${esc(fehler)}</div>` : ''}
  </div></div></div>`;

  el.querySelector<HTMLButtonElement>('[data-mmsp-druck]')?.addEventListener('click', () => drucken(daten));
}

function drucken(daten: MoodleDaten) {
  const zeilen = daten.termine.map(t => `<tr${t.status === 'entfaellt' ? ' style="text-decoration:line-through"' : ''}><td>${tag(t.datum)}, ${de(t.datum)}${t.datum.slice(0, 4)}</td><td>${esc(t.beginn)}–${esc(t.ende)}</td>
    <td>${esc(t.fachbereich?.name ?? '')}${t.thema ? ' · ' + esc(t.thema) : ''}${t.hinweis ? '<br><b>' + esc(t.hinweis) + '</b>' : ''}</td><td>${esc(t.dozent?.name ?? 'N. N.')}</td><td>${t.form === 'online' ? 'online' : esc(t.raum ?? '')}</td></tr>`).join('');
  const w = window.open('', '_blank'); if (!w) return;
  w.document.write(`<html lang="de"><head><meta charset="utf-8"><title>Stundenplan ${esc(daten.kurs.kennung)}</title><style>body{font-family:Calibri,Arial,sans-serif;color:#242424;margin:24px}h1{font-family:Arial;color:${esc(daten.mandant.farbe)};font-size:20px}table{border-collapse:collapse;width:100%;font-size:12px}th{background:${esc(daten.mandant.farbe)};color:#fff;text-align:left;padding:6px}td{border-bottom:1px solid #C9DCEF;padding:6px;vertical-align:top}</style></head><body>
    <h1>Stundenplan · ${esc(daten.kurs.bezeichnung)} (${esc(daten.kurs.kennung)})</h1><p>${esc(daten.mandant.name)} · Planstand ${esc(daten.kurs.planstand)}</p>
    <table><thead><tr><th>Tag</th><th>Zeit</th><th>Fach und Thema</th><th>Dozent/in</th><th>Ort</th></tr></thead><tbody>${zeilen}</tbody></table></body></html>`);
  w.document.close(); w.focus(); w.print();
}

/** Lädt den Stundenplan live aus Supabase und aktualisiert ihn regelmäßig. */
export function starte(el: HTMLElement, k: StartKonfig) {
  let letzte: MoodleDaten | null = null;
  const laden = async () => {
    try {
      const r = await fetch(`${k.url.replace(/\/$/, '')}/rest/v1/rpc/moodle_stundenplan`, {
        method: 'POST', headers: { apikey: k.key, Authorization: `Bearer ${k.key}`, 'Content-Type': 'application/json' },
        body: JSON.stringify({ p_token: k.token }),
      });
      if (!r.ok) throw new Error(`HTTP ${r.status}`);
      const daten = await r.json() as MoodleDaten | null;
      if (!daten) { el.innerHTML = '<p>Für diesen Kurs ist kein Stundenplan freigeschaltet. Bitte wenden Sie sich an die Kursleitung.</p>'; return; }
      letzte = daten;
      // Geöffnete Aufklapper beim Aktualisieren offen halten
      const offen = [...el.querySelectorAll('details')].map(x => x.open);
      zeichne(el, daten);
      el.querySelectorAll('details').forEach((x, i) => { if (offen[i]) x.open = true; });
    } catch {
      if (letzte) zeichne(el, letzte, undefined, 'Der Stundenplan konnte gerade nicht aktualisiert werden. Angezeigt wird der zuletzt geladene Stand.');
      else el.innerHTML = '<p>Der Stundenplan konnte nicht geladen werden. Bitte laden Sie die Seite später neu.</p>';
    }
  };
  void laden();
  const t = setInterval(laden, Math.max(30, k.intervallSek ?? 120) * 1000);
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') void laden(); });
  return () => clearInterval(t);
}
